<template>
    <DialogRoot>
        <DialogTrigger>
            <button class="bg-[#3c41e9] text-white px-[12px] rounded-xl h-[35px]">
                Ajouter profil
            </button>
        </DialogTrigger>
        <DialogPortal>
            <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
            <DialogContent className="fixed w-[48%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white pt-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                <DialogTitle class="m-0 text-[20px] font-medium text-center px-[25px] text-black">
                    Ajouter un nouveau profil
                </DialogTitle>
                <DialogDescription class="text-black px-8 mt-4 text-[15px] text-center font-extralight">
                    Les champs du formulaire suivis d'un <span class="text-[#f44545]">*</span> sont obligatoire. veuillez lire le formulaire
                    avant soummition
                </DialogDescription>
                <form @submit.prevent="addProfile">
                    <div class="flex flex-col w-full text-black px-[16px]">
                                <label for="libelle" class="font-light">Libéllé <span class="text-[#f44545]">*</span></label>
                                <input v-model="profildata.label" type="text" id="libelle" name="libelle" class="w-full h-[45px] border rounded-lg p-3"
                                    placeholder="Entrer le libéllé du département" required>
                    </div>

                    <div class="flex flex-col mt-[8px] w-full text-black px-[16px]">
                        <label for="user" class="font-light">Sélectionner un département <span class="text-[#f44545]">*</span></label>
                        <select v-model="profildata.department_id" name="user" id="user" class="h-[45px] w-full rounded-md border outline-none p-3 focus:outline-none">
                            <option value="">Choisissez le département</option>
                            <option v-for="departement in departements" :value="departement.id" :key="departement.id"> {{departement.name}} </option>
                        </select>
                    </div>


                    <div className="bg-[#f4f4f7] w-full py-4 mt-[8px] gap-x-[16px] px-[16px] rounded-b-md flex items-center justify-end">
                            <DialogClose asChild><button :disabled="asSend" class="px-8 h-[45px] py-3 text-[#797e91] transition-colors hover:bg-[#e9e9ec] rounded-xl">Cancel</button></DialogClose>
                            <button type="submit" class="h-[45px] w-[33%] bg-[#5357eb] rounded-xl text-white">
                                <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                <span v-if="!asSend">AJOUTER +</span>
                            </button>
                    </div>
                </form>
            </DialogContent>
        </DialogPortal>
    </DialogRoot>
</template>

<script>

import API from '@/service/API'
import Swal from 'sweetalert2'
import {
    Loader2
} from "lucide-vue-next";
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue'
export default {
    name: 'NewDepartementComponent',
    components: {
        Loader2,
        DialogClose,
        DialogContent,
        DialogDescription,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger,
    },
    data() {
        return {
            asSend: false,
            profildata: { label: null, department_id:null },
            departements: []
        }
    },
    mounted() {
        this.getAllDepartment();
    },
    methods: {
        getAllDepartment(){
            API.get("departements")
            .then(response => {
                if(response.data.status != "success") throw Error(response.data.message);
                this.departements = response.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        },
        async addProfile() {
            this.asSend = true;
            Swal.fire({
                title: "Confirmer l'ajout du département",
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    API.post('addProfile', this.profildata)
                        .then((res) => {
                            if (!res.data.status) throw Error(res.data.message);
                            this.$emit('child-action');
                            Swal.fire({title: 'Succès !',text: 'Profil ajouté avec succès',icon: 'success',})
                        })
                        .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                        .finally(()=>{
                            this.asSend = false;
                        })
                }
            })
        }
    }
}

</script>